var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button } from '../button';
import { Cross } from '../icon';
import { closeButtonStaticStyle } from './styles';
var sizeMap = {
    large: {
        buttonSize: 'medium',
        iconSize: 'small',
    },
    medium: {
        buttonSize: 'small',
        iconSize: 'xsmall',
    },
};
function CloseButton(_a) {
    var _b = _a["aria-label"], ariaLabel = _b === void 0 ? 'Close' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, restProps = __rest(_a, ['aria-label', "size"]);
    return (_jsx(Button, __assign({ "aria-label": ariaLabel, css: closeButtonStaticStyle, icon: _jsx(Cross, { size: sizeMap[size].iconSize }), size: sizeMap[size].buttonSize, variant: "plain" }, restProps)));
}
export default CloseButton;
